export enum FieldPropertyEnum {
  Number1 =  'Number1',
  Number2 = 'Number2',
  Desc1_1 = 'Desc1_1',
  Desc1_2 = 'Desc1_2',
  Desc1_3 = 'Desc1_3',
  Desc2_1 = 'Desc2_1',
  Desc2_2 = 'Desc2_2',
  Desc2_3 = 'Desc2_3',
  Text1 = 'Text1',
  Text2 = 'Text2',
  Text3 = 'Text3',
  Date1 = 'Date1',
  Date2 = 'Date2',
  Date3 = 'Date3',
  Attribute = 'Attribute',
  AttributeGroup_Image = 'AttributeGroup_Image',
  Structure = 'Structure',
  Company = 'Company',
  Craft = 'Craft',
  Order = 'Order',
  ContactCO = 'ContactCO',
  ContactCO_Company = 'ContactCO_Company',
  IsVisibleForCO = 'IsVisibleForCO',
  ContactCT =  'ContactCT',
  ContactCT_Company =  'ContactCT_Company',
  IsVisibleForCT = 'IsVisibleForCT',
  ContactSC = 'ContactSC',
  ContactSC_Company = 'ContactSC_Company',
  Class1 = 'Class1',
  Class2 = 'Class2',
  Class3 = 'Class3',
  Class4 = 'Class4',
  UserDefined1 = 'UserDefined1',
  UserDefined2 = 'UserDefined2',
  Opt1 = 'Opt1',
  Opt2 = 'Opt2',
  Opt3 = 'Opt3',
  Opt4 = 'Opt4',
  Opt5 = 'Opt5',
  Opt6 = 'Opt6',
  Opt7 = 'Opt7',
  Opt8 = 'Opt8',
  Opt9 = 'Opt9',
  Costs1 = 'Costs1',
  Costs2 = 'Costs2',
  Costs3 = 'Costs3',
  Costs4 = 'Costs4',
  Costs5 = 'Costs5',
  CostsCompany = 'CostsCompany',
  CostsOrder = 'CostsOrder',
  PlanId = 'PlanId',
  PlanPositionX = 'PlanPositionX',
  PlanPositionY = 'PlanPositionY',
}
